export default __webpack_public_path__ + "static/media/robson-jassa.1634106c.jpg";